<template>
    <div class="modal fade" id="itinerary_overview" :class="{ in: isShowModal, active: isShow}"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog" style="width: 750px;">
            <div class="modal-content">
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img class="common-modal-close" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>

                <div class="modal-body">
                    <div class="overreview_title">行程概览</div>
                    <div class="table_box">
                        <div class="table_hd">
                            <div class="table_tr">
                                <span class="date">日期</span>
                                <span class="destination_box">目的地</span>
                                <span class="loacl_time">抵港/起航(当地时间)</span>
                            </div>
                        </div>
                        <div class="table_bd">
                            <ul>
                                <li class="table_tr" v-for="(port, i) in ports" :key="('port_modal_'+i)">
                                    <span class="date">{{getDate(port)}}</span>
                                    <span class="destination_box">{{getTitle(port)}}</span>
                                    <span class="loacl_time">{{getTime(port)}}</span>
                                </li>
                                
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    name: "CruiseDetailRoutePopup",
    props: {
        isShow: {
            type: Boolean
        },
        ports: {
            type: Array
        },
        sailDate: {
            type: String
        }
    },
    data () {
        return {
            isShowModal: false
        }
    },
    methods: {
        getTitle (routeEvent) {
            const code = routeEvent.code
            if (code && code.indexOf("CRU") >= 0) {
                return "海上巡航"
            }
            let title = ""
            if (routeEvent.activity == "EMBARK" || routeEvent.activity == "DEBARK") {
              title += routeEvent.harborCNName
            } else {
                title += routeEvent.name
            }
            return title
        },
        getDate (routeEvent) {
            const date = moment(this.sailDate)
            return date.add(routeEvent.day-1, 'days').format('yyyy/MM/DD')
        },
        getTime (routeEvent) {
            let title = ''
            let arrivalTime = routeEvent.arrivalTime
            if (arrivalTime && arrivalTime.length > 0) {
                if (arrivalTime.length > 5) {
                    arrivalTime = arrivalTime.substring(0, 5)
                }
                title += "抵港 " + arrivalTime + "  "
            }

            let departureTime = routeEvent.departureTime
            if (departureTime && departureTime.length > 0) {
                if (departureTime.length > 5) {
                    departureTime = departureTime.substring(0, 5)
                }
                title += "起航 " + departureTime + "  "
            }

            return title
        },
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        }
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>

<style lang="less" scoped>

.modal.active {
    display: block;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}

#itinerary_overview {
    .overreview_title {
        font-size: 20px;
        color: #282b2c;
        padding-bottom: 20px;
    }
    .table_box {
        .table_tr {
            background: #54a3de;
            border-radius: 20px;
            color: #fff;
            margin-bottom: 10px;
            padding: 0 20px;
            .date {
                width: 110px;
            }
            .destination_box {
                width: 100px;
            }
            .loacl_time {
                width: 220px;
            }
        }
        .table_tr span {
            display: inline-block;
            margin-right: 10px;
        }
        .table_hd span {
            line-height: 40px;
        }

        .table_bd {
            .table_tr {
                background: #f3f6f8;
                color: #747d80;
                span {
                    line-height: 30px;
                }
            }
            .table_tr:hover {
                background: #747d80;
                color: #fff;
            }
        }
    }
}
</style>